export const AVENTRIA_LANDING_PAGE_FLAG_VALUES = {
  DIRECTORY: 'directory',
  INQUIRY: 'inquiry',
} as const;

export const AVENTRIA_PEER_SUPPORT_UTM_SOURCE = 'ps01';
export const AVENTRIA_SUBSPECIALIST_CONSULT_UTM_SOURCE = 'sc01';
